window.addEventListener('load', () => {
	const linkMessage = document.querySelector('.site-header__message');
	const modal = document.querySelector('.interstitial-modal');

	if (linkMessage) {
		linkMessage.querySelector('a').classList.add('site-header__message-link');
	}
	const closeButton = document.querySelectorAll('.close-modal');
	const linkButton = document.querySelector('.site-header__message-link');

	if (linkButton) {
		linkButton.addEventListener('click', (e) => {
			e.preventDefault();
			modal.classList.add('interstitial-modal--open');
		});
	}

	closeButton.forEach((button) => {
		button.addEventListener('click', () => {
			modal.classList.remove('interstitial-modal--open');
		});
	});
});
